import React from 'react';

const RING = 22;
const CIRC = 2 * Math.PI * RING;

const VARIANTS = {
  sidebar: {
    track: 'rgba(255,255,255,0.2)',
    accent: '#c3f02a',
    text: '#ffffff',
    subtext: '#ffffff',
  },
  light: {
    track: 'rgba(75,0,209,0.12)',
    accent: '#4b00d1',
    text: '#4b00d1',
    subtext: '#797487',
  },
  dark: {
    track: 'rgba(255,255,255,0.2)',
    accent: '#c3f02a',
    text: '#ffffff',
    subtext: 'rgba(255,255,255,0.85)',
  },
};

/**
 * Circular indicator for subscription days remaining.
 */
export default function SubscriptionDaysRing({
  daysLeft,
  totalDays,
  size = 56,
  variant = 'sidebar',
  accent,
}) {
  const colors = VARIANTS[variant] || VARIANTS.sidebar;
  const stroke = accent || colors.accent;
  const safeTotal = Math.max(1, totalDays);
  const safeLeft = Math.max(0, Math.min(daysLeft, safeTotal));
  const pct = safeLeft / safeTotal;
  const dashOffset = CIRC * (1 - pct);
  const label = safeLeft > 99 ? '99+' : String(safeLeft);
  const showDaysLabel = size >= 40;

  return (
    <svg width={size} height={size} viewBox="0 0 56 56" aria-hidden>
      <circle
        cx="28"
        cy="28"
        r={RING}
        fill="none"
        stroke={colors.track}
        strokeWidth="4"
      />
      <circle
        cx="28"
        cy="28"
        r={RING}
        fill="none"
        stroke={stroke}
        strokeWidth="4"
        strokeDasharray={CIRC}
        strokeDashoffset={dashOffset}
        strokeLinecap="round"
        transform="rotate(-90 28 28)"
      />
      <text
        x="28"
        y={showDaysLabel ? 30 : 32}
        textAnchor="middle"
        fill={colors.text}
        fontSize={label.length > 2 ? 11 : size >= 44 ? 14 : 12}
        fontWeight="800"
        fontFamily="Plus Jakarta Sans, sans-serif"
      >
        {label}
      </text>
      {showDaysLabel && (
        <text
          x="28"
          y="42"
          textAnchor="middle"
          fill={colors.subtext}
          fontSize="7"
          fontWeight="600"
          fontFamily="Plus Jakarta Sans, sans-serif"
        >
          days
        </text>
      )}
    </svg>
  );
}
